<template>
  <div class="event-subscribe">
    <button class="event-subscribe-close-button" aria-label="Close Calendar Subscribe" @click="close">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="event-subscribe-tabs">
      <button
        type="button"
        aria-controls="event-subscribe-email"
        :class="{ 'is-active': this.activeTab === 'email' }"
        :aria-expanded="activeTab === 'email' ? 'true' : 'false'"
        @click="setTab('email')"
      >
        Subscribe By Email
      </button>

      <button
        type="button"
        aria-controls="event-subscribe-calendar"
        :class="{ 'is-active': this.activeTab === 'calendar' }"
        :aria-expanded="activeTab === 'calendar' ? 'true' : 'false'"
        @click="setTab('calendar')"
      >
        Subscribe In Your Calendar
      </button>
    </div>

    <div id="event-subscribe-email" class="event-subscribe__section" v-if="activeTab === 'email'">
      <div class="event-subscribe__title">Please choose the categories you want to subscribe to</div>

      <form @submit.prevent="handleSubmit">
        <ul class="ignore-list event-subscribe-categories">
          <li v-for="filter in filters" :key="filter.id">
            <input
              :id="filterId(filter.id)"
              type="checkbox"
              name="categories[]"
              :value="filter.id"
              v-model="subscribe.categories"
              @change="handleCheckAll"
            />

            <label :for="filterId(filter.id)">{{ filter.title }}</label>
          </li>
        </ul>

        <div class="input-group">
          <input type="email" name="email" placeholder="Please Enter Your Email..." v-model="subscribe.email"/>
          <button type="submit">Subscribe</button>
        </div>

        <div v-if="formMessage" class="event-subscribe-message">
          {{ formMessage }}
        </div>
      </form>
    </div>

    <div id="event-subscribe-calendar" class="event-subscribe__section" v-if="activeTab === 'calendar'">
      <div class="event-subscribe__title">Clicking the "Add to Your Calendar" link will open your Calendar application.</div>

      <ul class="ignore-list event-subscribe-links">
        <li v-for="filter in filters" :key="filter.id">
          <strong>{{ filter.title }}</strong>
          <a :href="filter.webcal_link + filter.id" target="_blank">Add to Your Calendar</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'CalendarSubscribe',

  data() {
    return {
      activeTab: 'email',
      subscribe: {
        categories: [],
        email: null
      },
      formMessage: null
    }
  },

  computed: {
    ...mapState([
      'assets',
      'filters'
    ])
  },

  methods: {
    ...mapMutations([
    ]),

    filterId(id) {
      return `subscribe-filter-${id}`
    },

    setTab(type) {
      this.activeTab = type
    },

    close() {
      this.$parent.toggleSubscribe()
    },

    handleCheckAll(e) {
      if (e.target.id === 'subscribe-filter-all') {
        if (e.target.checked) {
          this.subscribe.categories = this.filters.map(f => f.id)
        } else {
          this.subscribe.categories = []
        }
      } else {
        if (!e.target.checked) {
          const allCheck = this.subscribe.categories.indexOf('all')

          if (allCheck !== -1) {
            this.subscribe.categories.splice(allCheck, 1)
          }
        }
      }
    },

    handleSubmit(e) {
      this.formMessage = null

      if (!this.subscribe.email) {
        this.formMessage = 'Please enter an email address'
      }

      if (!this.subscribe.categories.length) {
        this.formMessage = 'Please select at least one category'
      }

      if (this.subscribe.email && this.subscribe.categories.length) {
        const endpoint = window._eventsRootUrl + 'subscribe'

        $.post(endpoint, this.subscribe)
          .then(resp => {
            if (resp.success) {
              this.formMessage = 'You have successfully subscribed.'
              this.subscribe.categories = []
              this.subscribe.email = null
            }

            if (resp.message) {
              this.formMessage = resp.message
            }
          })
      }
    }
  }
}
</script>
